<template>
  <div class="connectors">
    <button
      v-for="connector in connectors"
      :key="connector.id"
      class="connector"
      @click="emit('connect', connector)"
    >
      <AppIcon :name="connector.type" />
      {{ connector.name }}
    </button>
  </div>
</template>

<script setup>
import { useConnect } from '@wagmi/vue'

const { connectors } = useConnect()
const emit = defineEmits(['connect'])
</script>

<style lang="scss" scoped>
.connectors {
  display: flex;
  flex-direction: column;
  gap: 16px;

    .connector {
      display: flex;
      gap: 8px;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      transition: .3s ease-in-out;
      color: $white;
      background-color: transparent;
      border: none;
      outline: none;
      text-decoration: underline;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: $yellow-100;
      }
    }
}
</style>